import React from 'react';

const BlogHero = () => (
  <section className="py-20 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center space-y-6">
        <h1 className="text-5xl md:text-6xl font-bold text-white">
          Industry
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-500"> Insights</span>
        </h1>
        <p className="text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed">
          Expert knowledge, industry trends, and professional insights from automotive detailing industry leaders
        </p>
      </div>
    </div>
  </section>
);

export default BlogHero;
